import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { Button } from "reactstrap";
import './Default.css';

function DefaultButton({children, onClick, disabled, loading, ...rest}) {
  return(
    <Button color="primary" onClick={onClick} disabled={disabled} {...rest}>
      {loading ? <AiOutlineLoading3Quarters className="animation-spin" /> : children}
    </Button>
  );
}

export default DefaultButton;